import React, { useEffect, useRef, useState } from 'react'
import Modal from '../../../../common/modal'
import { Box, Button, Divider, Grid, Typography, Paper, Stack } from '@mui/material'
import DropDownOA from '../../../../common/dropDownOA'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { fontSizeArray, formatType, formatTypeList, imgList, ratioList, satusList, statusList } from '../../GSConstants'
import { focusElemnt, navigation1, navigation3 } from '../../../../common/helper'
import * as mdt from '../../../../common/modaltypes'
import Lineinput from '../../../../common/lineinput'
import IconButton from '@mui/material/IconButton'
import FormatBoldIcon from '@mui/icons-material/FormatBold'
import FormatItalicIcon from '@mui/icons-material/FormatItalic'
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined'
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft'
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight'
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import KeyboardBackspaceRoundedIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import DragAndDropContainer from '../../../../common/DragAndDrop/dragDropContainer'
import { clampRectToTicket, getUseableArea } from '../../GSConstants'
import { useTranslation } from '../../../../../i18n/I18nProvider'
import {
  createEmptyCell,
  createEmptyCells,
  decodeTable,
  encodeTable,
  isTableToken,
  sanitizeCellText,
} from '../../../../common/ticketTableFormat'
const CreateNewFormatDesign = (props) => {
  const { updateModal, headTxt, isUpdate, updateAlertError, labelList, editData, updateTicketFormat, loginData,getCargoTicketFormatList} = props
  const { translations, language } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const mapTranslated = (list = []) =>
    list.map((item) => ({ ...item, name: tr(item.translationKey, item.name) }))
  const translatedStatusList = mapTranslated(statusList)
  const activeStatus = () => translatedStatusList.find((item) => item.id === 1) || translatedStatusList[0]
  const inactiveStatus = () => translatedStatusList.find((item) => item.id === 0) || translatedStatusList[1]
  const [ticketFormatName, setTicketFormatName] = useState()
  const [ticketWidth, setTicketWidth] = useState()
  const [ticketHeight, setTicketHeight] = useState()
  const [ticketHeaderHeight, setTicketHeaderHeight] = useState(0)
  const [ticketFooterHeight, setTicketFooterHeight] = useState(0)
  const [isTicketGenerate, setIsTicketGenerate] = useState(false)
  const [isBold, setBold] = useState(false)
  const [isItalic, setItalic] = useState(false)
  const [isUnderline, setUnderline] = useState(false)
  const [imgHeight, setImgHeight] = useState()
  const [imgWidth, setImgWidth] = useState()
  const [lblText, setLblText] = useState(labelList[0]?.TicketFormatLabelName)
  const [lblTextValuePriprinted, setLblTextValuePriprinted] = useState(labelList[0]?.TicketFormatLabelValue)
  const [lblFont, setLblFont] = useState(fontSizeArray[0]?.id)
  const [selectedRatio, setSelectedRatio] = useState('1:1')
  const [imgType, setImgType] = useState('Logo')
  const [margin, setMargin] = useState({ left: 0, right: 0, up: 0, down: 0 })
  const [marginInfo, setMarginInfo] = useState({ left: 0, right: 0, up: 0, down: 0 })
  const [horizontal, setHorizontal] = useState(0) // Default value in millimeters
  const [vertical, setVertical] = useState(0) // Default value in millimeters
  const [thermalSplitter, setThermalSplitter] = useState({ horizontal: 0, vertical: 0 })
  const [tableInfo, setTableInfo] = useState({ row: 0, col: 0, tblWidth: 0, tblHeight: 0, alignment: 'left', isAlignment: false })
  const [items, setItems] = useState([])
  const [formatType, setFormatType] = useState()
  const [scale, setScale] = useState(1)
  const [isActive, setIsActive] = useState(statusList.find((item) => item.id === 1) || statusList[0])
  const handleZoomIn = () => {
    setScale((scale) => scale * 1.2)
  }
  const handleZoomOut = () => {
    setScale((scale) => scale / 1.2)
  }
  const handleZoomReset = () => {
    setScale(1)
  }
  const handleAddItem = (text, font, isBold, isItalic, isUnderline, left = 10, top = 10, id, height, width, bgColor = 'white') => {
    setItems([
      ...items,
      {
        text,
        font,
        isBold,
        isItalic,
        isUnderline,
        left,
        top,
        id,
        height,
        width,
        bgColor,
      },
    ])
  }
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  useEffect(() => {
    // adjustPositionWithMargin() //handle margin at page load
    focusElemnt('formatName')
  }, [])
  useEffect(() => {
    setIsActive((prev) => translatedStatusList.find((item) => item.id === prev?.id) || translatedStatusList[0])
  }, [translations])
  useEffect(() => {
    if (isUpdate) {
      setTicketFormatName(editData?.TicketFormatName)
      setFormatType(editData?.TicketFormatType === 'P' ? { id: 1, name: 'PRE-PRINTED', translationKey: 'wbPrePrinted' } : { id: 0, name: 'BLANK', translationKey: 'wbBlank' })
      //---------decode ticket height, width, header height and marginLeft from DIMENSION-------
      const dimensionString = editData?.DIMENSION
      const dimensionsArray = dimensionString.split(',')
      const [tktHeight,tktWidth,  tktHeaderHeight, txtSeperationDistance] = dimensionsArray
      setTicketHeight(tktHeight)
      setTicketWidth(tktWidth)
      setTicketHeaderHeight(tktHeaderHeight)
      setMarginInfo((prevMargin) => ({ ...prevMargin, left: txtSeperationDistance }))
      adjustPositionWithMargin()
      setIsActive(editData?.IsDeleted === 0 ? activeStatus() : inactiveStatus())
      //------------decode label data and thermalPrintSplitterData from TicketFormat-----------
      let ticketFormatData = editData?.TicketFormat?.split('^')
      const labelsData = []
      let thermalPrintSplitterData = null
      ticketFormatData.forEach((labelString) => {
        if (!labelString) return
        if (isTableToken(labelString)) {
          labelsData.push(decodeTable(labelString))
          return
        }
        const [labelName, placeholder, left, top, fontSize, alignment, isDeleted] = labelString.split('|')
        const isBold = alignment === 'D' ? 1 : 0
        if (labelName !== 'lblThermalPrintSplitter' && labelName !== '' && labelName !== undefined) {
          labelsData.push({
            text: alignment === 'D' ? `${labelName.replace(/^lbl|Val$/g, '')}` : `${placeholder}`,
            font: fontSize,
            isBold: parseInt(isBold),
            left: parseInt(left),
            top: parseInt(top),
            id: Math.random().toString(36).substring(7),
          })
        } else if (labelName === 'lblThermalPrintSplitter') {
          thermalPrintSplitterData = {
            text: labelName,
            font: fontSize,
            isBold: parseInt(isBold),
            left: parseInt(left),
            top: parseInt(top),
            id: Math.random().toString(36).substring(7),
          }
        }
      })
      setItems(labelsData)
      const topInMm = pxToMm(thermalPrintSplitterData?.top)
      setHorizontal(thermalPrintSplitterData == null ? 0 : topInMm) //getting in px
      setThermalSplitter((prev) => ({ ...prev, horizontal: thermalPrintSplitterData == null ? 0 : topInMm }))
      //------------- decode QR and Logo from QRandLogoFormat----------------
      decodeAndProcessData(editData?.QRandLogoFormat, labelsData, setItems)
    }
  }, [isUpdate])
  const pxToMm = (px) => {
    // 1 inch = 25.4 millimeters
    // 1 inch = 96 pixels (standard for web)
    // 1 pixel = 25.4 / 96 millimeters
    const mmPerPx = 25.4 / 96
    return (px * mmPerPx).toFixed(0)
  }
  const decodeAndProcessData = (dataString, existingItems, setItems) => {
    if (!dataString) return
    const dataItems = dataString.split('^').filter((item) => item.trim() !== '')
    const processedData = dataItems.map((item, index) => {
      const [text, left, top, height, width] = item.split('|')
      return {
        ...items,
        text,
        font: 9,
        isBold: 0,
        left: parseInt(left),
        top: parseInt(top),
        id: Math.random().toString(36).substring(7),
        height: parseInt(height),
        width: parseInt(width),
        bgColor: 'lightblue',
      }
    })

    // Merge processedData with existing items array
    const updatedItems = [...existingItems, ...processedData]
    // Update state with the merged array
    setItems(updatedItems)
  }
  const encodeObjects = (dataArray) => {
    let encodedString = ''
    dataArray.forEach((obj) => {
      if (obj.type === 'table') {
        encodedString += encodeTable(obj)
        return
      }
      if (!obj.text) {
        return
      }
      // Skip objects with text "Logo" or "QR"
      if (obj.text === 'Logo' || obj.text === 'QR') {
        return // Skip this iteration of the loop
      }
      if (obj.text.includes('@@')) {
        const encodedLabelValueObj = `^lbl${obj.text?.replace(/@/g, '')}Val|${obj.text}|${Math.round(obj.left)}|${Math.round(obj.top)}|${
          obj.font
        }|V|${obj.isBold ? '1' : '0'}`
        encodedString += encodedLabelValueObj
      } else if (obj.text.includes('ThermalPrintSplitter')) {
        let thermalTopInPx = mmToPx(horizontal)
        const encodedLabelThermalPrintSplitterObj = `^lblThermalPrintSplitter|--THERMAL-PRINT-SPLITTER--|0|${Math.round(
          thermalTopInPx
        )}|8|D|1`
        encodedString += encodedLabelThermalPrintSplitterObj
      } else {
        const encodedObj = `^lbl${obj.text}|${obj.text}|${Math.round(obj.left)}|${Math.round(obj.top)}|${obj.font}|D|${
          obj.isBold ? '1' : '0'
        }`
        // Append the encoded object to the encoded string
        encodedString += encodedObj
      }
    })
    return encodedString
  }
  const mmToPx = (mm) => {
    // 1 inch = 25.4 millimeters
    // 1 inch = 96 pixels (standard for web)
    // 1 millimeter = 96 / 25.4 pixels
    const pxPerMm = 96 / 25.4
    return mm * pxPerMm
  }
  const handleSaveAndUpdateTicket = () => {
    handleAddThermalPrintSplitter() //to add thraml splitter to items
    // ----------encode data for labels---------
    const encodedData = encodeObjects(items) //this items doesn't contain thermal splitter
    // ----------encode data for QR and Logo-----------
    const encodedArray = items.map((obj) => {
      if (obj.text === 'QR' || obj.text === 'Logo') {
        // Encode the object according to the specified format
        return `^${obj.text}|${Math.round(obj.left)}|${Math.round(obj.top)}|${obj.height}|${obj.width}`
      }
    })
    const filteredEncodedObjects = encodedArray.filter(
      (encodedObj) => encodedObj && (encodedObj.startsWith('^QR|') || encodedObj.startsWith('^Logo|'))
    )
    const concatenatedString = filteredEncodedObjects.join('')
    let strDimension = ticketHeight + ',' + ticketWidth + ',' + ticketHeaderHeight + ',' + margin?.left
    const body = {
      intTicketFormatID: isUpdate ? parseInt(editData?.TicketFormatID) : 0,
      strTicketFormatName: ticketFormatName,
      strTicketFormatType: formatType?.id === 1 ? 'P' : 'B',
      strTicketFormat: encodedData,
      strDimension: strDimension,
      intCompanyID: loginData?.intCompanyID,
      intBranchID: loginData?.intBranchID,
      strQRandLogo: concatenatedString,
      IsDeleted: isActive?.id === 0 ? 1 : 0,
    }
    // console.log(body)
    updateTicketFormat(body)
      .then((res) => {
        if (res.status === 'Success') {
          updateModal(false, mdt.ticketFormatCreate)
          updateAlertError({ show: true, msg: tr('wbTicketFormatUpdated', 'Ticket Format Updated Successfully..! '),success: true, nextId: 'formatName' })
          const obj1 = {
            intTicketFormatID: 0,
            intCompanyID: loginData.intCompanyID,
            intIsDeleted: -1,
            // strFormatType: '',
          }
          getCargoTicketFormatList(obj1)
        } else {
          updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
        }
      })
      .catch((err) => {
        console.log('Error:', err)
      })
  }
  const hasSelectedTableCell = (item) =>
    item?.type === 'table' && item.cells?.some((row) => row.some((cell) => cell.isSelected))
  const applyToTableCells = (item, patch) => {
    const anyCellSelected = hasSelectedTableCell(item)
    if (!anyCellSelected && !item.isSelected) return item
    return {
      ...item,
      cells: (item.cells || []).map((row) =>
        row.map((cell) => {
          if (anyCellSelected ? cell.isSelected : item.isSelected) {
            return { ...cell, ...patch }
          }
          return cell
        })
      ),
    }
  }
  const handleToggleBold = () => {
    const nextBold = !isBold
    setBold(nextBold)
    const updatedItems = items.map((item) => {
      if (item.type === 'table') {
        return applyToTableCells(item, { isBold: nextBold })
      }
      if (item.isSelected) {
        return {
          ...item,
          isBold: nextBold,
        }
      }
      return item
    })
    setItems(updatedItems)
  }
  const handleToggleItalic = () => {
    const nextItalic = !isItalic
    setItalic(nextItalic)
    const updatedItems = items.map((item) => {
      if (item.type === 'table') {
        return applyToTableCells(item, { isItalic: nextItalic })
      }
      if (item.isSelected) {
        return {
          ...item,
          isItalic: nextItalic,
        }
      }
      return item
    })
    setItems(updatedItems)
  }
  const handleToggleUnderline = () => {
    const nextUnderline = !isUnderline
    setUnderline(nextUnderline)
    const updatedItems = items.map((item) => {
      if (item.type === 'table') {
        return applyToTableCells(item, { isUnderline: nextUnderline })
      }
      if (item.isSelected) {
        return {
          ...item,
          isUnderline: nextUnderline,
        }
      }
      return item
    })
    setItems(updatedItems)
  }
  const handleFontChange = (val) => {
    setLblFont(val.id)
    const updatedItems = items.map((item) => {
      if (item.type === 'table' && (item.isSelected || hasSelectedTableCell(item))) {
        return {
          ...item,
          font: val.id,
          cells: (item.cells || []).map((row) => row.map((cell) => ({ ...cell, fontSize: val.id }))),
        }
      }
      if (item.isSelected) {
        return {
          ...item,
          font: val.id,
        }
      }
      return item
    })
    setItems(updatedItems)
  }
  const handleHeightChange = (e) => {
    const height = e.target.value
    let calculatedWidth
    setImgHeight(e.target.value)
    const [ratioWidth, ratioHeight] = selectedRatio.split(':').map(Number)
    if (!isNaN(height) && ratioHeight !== 0) {
      calculatedWidth = (height * ratioWidth) / ratioHeight
      setImgWidth(calculatedWidth.toFixed(0))
      // setImgWidth(isNaN(calculatedWidth) ? 'Invalid input' : calculatedWidth.toFixed(0))
    }

    // Update the height and width of selected items if they are Logo, or QR
    const updatedItems = items.map((item) => {
      if (item.isSelected && (item.text === 'Logo' || item.text === 'QR')) {
        return {
          ...item,
          height: height,
          width: calculatedWidth.toFixed(0),
        }
      }
      return item
    })
    setItems(updatedItems)
  }
  const updateSetItems = (next) => {
    setItems((prev) => (typeof next === 'function' ? next(prev) : [...next]))
  }
  const handleRatioChange = (e) => {
    const ratio = e.name
    let calculatedWidth
    setSelectedRatio(e.name)
    const [ratioWidth, ratioHeight] = ratio.split(':').map(Number)
    if (!isNaN(imgHeight) && ratioHeight !== 0) {
      calculatedWidth = (imgHeight * ratioWidth) / ratioHeight
      setImgWidth(calculatedWidth.toFixed(0))
      // setImgWidth(isNaN(calculatedWidth) ? 'Invalid input' : calculatedWidth.toFixed(0))
    }

    // Update the height and width of selected items if they are Logo, or QR
    const updatedItems = items.map((item) => {
      if (item.isSelected && (item.text === 'Logo' || item.text === 'QR')) {
        return {
          ...item,
          height: imgHeight,
          width: calculatedWidth.toFixed(0),
        }
      }
      return item
    })
    setItems(updatedItems)
  }
  const getMoveCoordinates = (direction, item) => {
    let { left, top, id } = item
    left = parseFloat(left || '0')
    top = parseFloat(top || '0')
    const useArea = getUseableArea('containerId', margin)
    const ele = document.getElementById(id)
    const itemWidth = ele?.offsetWidth || 0
    const itemHeight = ele?.offsetHeight || 0
    switch (direction) {
      case 'left':
        left = left - 10 < useArea.left ? useArea.left : left - 10
        break
      case 'right':
        left = left + 10 > useArea.right - itemWidth ? useArea.right - itemWidth : left + 10
        break
      case 'up':
        top = top - 10 < useArea.top ? useArea.top : top - 10
        break
      case 'down':
        top = top + 10 > useArea.bottom - itemHeight ? useArea.bottom - itemHeight : top + 10
        break

      default:
        break
    }
    return { left, top }
  }
  const moveItem = (direction) => {
    // Move the selected item in the specified direction
    //getUseableArea use
    setItems((prevItems) =>
      prevItems.map((item) =>
        item.isSelected
          ? {
              ...item,
              ...getMoveCoordinates(direction, item),
              // left: direction === 'right' ? item.left + 10 : direction === 'left' ? item.left - 10 : item.left,
              // top: direction === 'down' ? item.top + 10 : direction === 'up' ? item.top - 10 : item.top,
            }
          : item
      )
    )
  }
  const handleSelectAll = () => {
    setItems((prevItems) => prevItems.map((item) => ({ ...item, isSelected: true })))
  }
  const clearSelectedItems = () => {
    setItems((prevItems) =>
      prevItems
        .filter((item) => {
          if (item.type === 'table' && hasSelectedTableCell(item)) return true
          return !item.isSelected
        })
        .map((item) => {
          if (item.type !== 'table' || !hasSelectedTableCell(item)) return item
          return {
            ...item,
            cells: (item.cells || []).map((row) =>
              row.map((cell) =>
                cell.isSelected
                  ? { ...createEmptyCell(cell.fontSize || item.font), isSelected: true }
                  : cell
              )
            ),
          }
        })
    )
  }
  const adjustPositionWithMargin = () => {
    //onclick of add set all margin to state
    setMargin({ left: marginInfo?.left, right: marginInfo?.right, up: marginInfo?.up, down: marginInfo?.down })
    setItems((prevItems) =>
      prevItems.map((item) => ({
        ...item,
        left: parseInt(item.left) > parseInt(marginInfo.left) ? item.left : marginInfo.left,
        top: parseInt(item.top) > parseInt(marginInfo.up) ? item.top : marginInfo.up,
      }))
    )
    //handled top and left need to handle bottom and right
  }
  const handleAddThermalPrintSplitter = () => {
    setHorizontal(thermalSplitter.horizontal)
    handleAddItem(
      'ThermalPrintSplitter',
      9,
      1,
      isItalic,
      isUnderline,
      0,
      mmToPx(horizontal), //handled it while passing in api
      Math.random().toString(36).substring(7)
    )
  }
  const calculateNewLeft = (item, alignment) => {
    const useArea = getUseableArea('containerId', margin)
    let a = document.getElementById(item.id)
    const itemWidth = a?.offsetWidth || 0
    switch (alignment) {
      case 'left':
        return useArea?.left // Set the desired left position for left alignment
      case 'right':
        return useArea?.right - itemWidth
      case 'center':
        return (useArea?.right - itemWidth) / 2 // Set the desired left position for center alignment
      default:
        return item.left
    }
  }
  const alignSelectedItems = (alignment) => {
    setItems((prevItems) => prevItems.map((item) => (item.isSelected ? { ...item, left: calculateNewLeft(item, alignment) } : item)))
  }
  const getLabelPlaceholder = () => {
    if (lblTextValuePriprinted?.includes('@')) return lblTextValuePriprinted
    return `@@${lblTextValuePriprinted || lblText}@`
  }
  const handleAddTwoItems = () => {
    const placeholder = sanitizeCellText(getLabelPlaceholder())
    let insertedIntoCell = false
    const withCellLabels = items.map((item) => {
      if (item.type !== 'table' || !hasSelectedTableCell(item)) return item
      insertedIntoCell = true
      return {
        ...item,
        cells: item.cells.map((row) =>
          row.map((cell) =>
            cell.isSelected
              ? { ...cell, content: [cell.content, placeholder].filter(Boolean).join(' ') }
              : cell
          )
        ),
      }
    })
    if (insertedIntoCell) {
      setItems(withCellLabels)
      return
    }
    const newItem1 = {
      text: `${lblText}`,
      font: lblFont,
      isBold: true,
      isItalic: isItalic,
      isUnderline: isUnderline,
      left: 10,
      top: 10,
      id: Math.random().toString(36).substring(7),
    }

    const newItem2 = {
      text: `@@${lblTextValuePriprinted}@`,
      font: lblFont,
      isBold: isBold,
      isItalic: isItalic,
      isUnderline: isUnderline,
      left: 100,
      top: 10,
      id: Math.random().toString(36).substring(7),
    }

    setItems([...items, newItem1, newItem2])
  }
  const alignTableCells = (alignment) => {
    setTableInfo((prevInfo) => ({ ...prevInfo, alignment, isAlignment: true }))
    setItems((prevItems) =>
      prevItems.map((item) => {
        if (item.type !== 'table' || !hasSelectedTableCell(item)) return item
        return {
          ...item,
          cells: (item.cells || []).map((row) =>
            row.map((cell) => (cell.isSelected ? { ...cell, alignment } : cell))
          ),
        }
      })
    )
  }
  const handleAddTable = () => {
    const rows = parseInt(tableInfo.row, 10)
    const cols = parseInt(tableInfo.col, 10)
    const cellWidth = parseInt(tableInfo.tblWidth, 10)
    const cellHeight = parseInt(tableInfo.tblHeight, 10)
    if (!rows || !cols || !cellWidth || !cellHeight || rows < 1 || cols < 1) {
      updateAlertError({
        show: true,
        msg: tr('wbTableRequired', 'Table rows, columns and cell size are required..! '),
        nextId: 'tblRow',
      })
      return
    }
    const id = Math.random().toString(36).substring(7)
    const tableWidth = cols * cellWidth
    const tableHeight = rows * cellHeight
    const bounds = getUseableArea('containerId', margin)
    const position = clampRectToTicket(bounds.left, bounds.top, tableWidth, tableHeight, bounds)
    const newTable = {
      type: 'table',
      text: 'TABLE',
      font: lblFont,
      isBold,
      isItalic,
      isUnderline,
      left: position.left,
      top: position.top,
      id,
      rows,
      cols,
      cellWidth,
      columnWidths: Array.from({ length: cols }, () => cellWidth),
      cellHeight,
      rowHeights: Array.from({ length: rows }, () => cellHeight),
      width: tableWidth,
      height: tableHeight,
      alignment: tableInfo.alignment || 'left',
      cells: createEmptyCells(rows, cols, lblFont),
      isSelected: true,
    }
    setItems([...items.map((item) => ({ ...item, isSelected: false })), newTable])
  }
  const handleGenerate = () => {
    if (ticketFormatName == '' || formatType == '' || ticketWidth == undefined || ticketHeight == undefined) {
      updateAlertError({ show: true, msg: tr('wbTicketDimRequired', 'Ticket Dimensions And Format Name Required..! '), nextId: 'formatName' })
    } else {
      setIsTicketGenerate(true)
    }
  }
  const navigationDirectionBtn = (e, nextItemId, prevItemId) => {
    if (e.key === 'Escape') {
      focusElemnt(prevItemId)
    }
    if (e.key === 'Enter') {
      focusElemnt(nextItemId)
      e.preventDefault()
    }
    const selectedItems = items.filter((item) => item.isSelected)
    if (selectedItems.length > 0) {
      switch (e.key) {
        case 'ArrowLeft':
          moveItem('left')
          break
        case 'ArrowUp':
          moveItem('up')
          break
        case 'ArrowRight':
          moveItem('right')
          break
        case 'ArrowDown':
          moveItem('down')
          break
        default:
          break
      }
    }
  }
  return (
    <Modal
      headTxt={headTxt}
      width={'90%'}
      updateModal={updateModal}
      closeId={'closeButton'}
      modalClass={'booking-popup'}
      modalStyle={modalStyle}
    >
      <Stack style={{ maxHeight: '90vh', paddingLeft: '16px', paddingRight: '16px', paddingTop: '12px' }}>
        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box sx={{ padding: '8px', paddingLeft: '0px' }} className={'input--wrapper'}>
            <Lineinput
              id={'formatName'}
              label={tr('wbFormatName', 'Format Name')}
              type="text"
              name="formatName"
              value={ticketFormatName}
              sx={{ margin: '8px', width: '100%' }}
              onChange={(e) => {
                setTicketFormatName(e.target.value)
              }}
              onKeyDown={(e) => navigation1(e, 'ticketHeight', 'formatName')}
              //onBlur={(e) => handleHelplineNumberChange(e)}
            />
          </Box>
          <Box sx={{ padding: '8px' }} className={'input--wrapper'}>
            <Lineinput
              id={'ticketHeight'}
              label={tr('wbTicketHtMm', 'Ticket Ht.(MM)')}
              type="text"
              name="ticketHeight"
              value={ticketHeight}
              onChange={(e) => setTicketHeight(e.target.value)}
              // onBlur={(e) => {
              //   handleWebsiteChange(e)
              // }}
              onKeyDown={(e) => navigation1(e, 'ticketWidth', 'formatName')}
              style={{ with: '75%' }}
            />
          </Box>
          <Box sx={{ padding: '8px' }} className={'input--wrapper'}>
            <Lineinput
              id={'ticketWidth'}
              label={tr('wbTicketWMm', 'Ticket W.(MM)')}
              type="text"
              name="ticketWidth"
              value={ticketWidth}
              sx={{ margin: '8px', width: '100%' }}
              onChange={(e) => setTicketWidth(e.target.value)}
              // onBlur={(e) => {
              //   handleWebsiteChange(e)
              // }}
              onKeyDown={(e) => navigation1(e, 'ticketHeaderHeight', 'ticketHeight')}
            />
          </Box>
          <Box sx={{ padding: '8px' }} className={'input--wrapper'}>
            <Lineinput
              id={'ticketHeaderHeight'}
              label={tr('wbTicketHeaderHtMm', 'Ticket Header Ht.(MM)')}
              type="text"
              name="ticketHeaderHeight"
              value={ticketHeaderHeight}
              sx={{ margin: '8px', width: '100%' }}
              onChange={(e) => setTicketHeaderHeight(e.target.value)}
              // onBlur={(e) => {
              //   handleWebsiteChange(e)
              // }}
              onKeyDown={(e) => navigation1(e, 'formatType', 'ticketWidth')}
            />
          </Box>
          <Box sx={{ padding: '8px' }} className={'input--wrapper'}>
            <Lineinput
              id={'ticketFooterHeight'}
              label={tr('wbTicketFooterHtMm', 'Ticket Footer Ht.(MM)')}
              type="text"
              name="ticketFooterHeight"
              value={ticketFooterHeight}
              sx={{ margin: '8px', width: '100%' }}
              onChange={(e) => setTicketFooterHeight(e.target.value)}
              // onBlur={(e) => {
              //   handleWebsiteChange(e)
              // }}
              onKeyDown={(e) => navigation1(e, 'formatType', 'ticketHeaderHeight')}
              disabled
            />
          </Box>
          <Box sx={{ padding: '8px' }} className={'input--wrapper'}>
            <DropDownOA
              id={'formatType'}
              label={tr('wbFormatType', 'Format Type')}
              data={formatTypeList}
              value={formatType?.name}
              defaultvalue={formatType?.name}
              idKey={`id`}
              dataKey={`name`}
              width="100%"
              nextId={'generateButton'}
              prevId={'ticketHeaderHeight'}
              onSelect={(val) => {
                setFormatType(formatTypeList.find((f) => f.id === val.id) || val)
              }}
            />
          </Box>

          <Button
            id="generateButton"
            style={{ margin: '0', height: '40px', marginTop: '8px', marginLeft: '8px' }}
            className="btn add-btn"
            variant="contained"
            color="error"
            onClick={() => {
              handleGenerate()
              // setIsTicketGenerate(true)
            }}
            onKeyDown={(e) => navigation3(e, `label`, `formatType`)}
          >
            {tr('wbGenerate', 'Generate')}
          </Button>
        </Box>
        <Divider />
        <Stack
          direction="row"
          divider={<Divider orientation="vertical" flexItem />}
          spacing={2}
          // style={{ display: isUpdate || isTicketGenerate ? '' : 'none' }}
          style={{ display: isUpdate ? '' : isTicketGenerate ? '' : 'none' }}
        >
          <Box style={{ display: 'flex', width: '50%' }}>
            <Box sx={{ padding: '8px', paddingLeft: '0px', marginTop: '5px' }} className={'input--wrapper'}>
              <DropDownOA
                id={'label'}
                label={tr('wbLabels', 'Labels')}
                data={labelList}
                defaultvalue={labelList[0]?.TicketFormatLabelName}
                value={lblText}
                idKey={`TicketFormatLabelsID`}
                dataKey={`TicketFormatLabelName`}
                width="100%"
                nextId={'fontSize'}
                prevId={'generateButton'}
                onSelect={(val) => {
                  setLblText(val.TicketFormatLabelName)
                  setLblTextValuePriprinted(val.TicketFormatLabelValue)
                }}
              />
            </Box>
            <Box sx={{ padding: '8px', marginTop: '5px' }} className={'input--wrapper'}>
              <DropDownOA
                id={'fontSize'}
                label={tr('wbFontSize', 'Font Size')}
                data={fontSizeArray}
                defaultvalue={fontSizeArray[0].id}
                value={lblFont}
                idKey={`id`}
                dataKey={`id`}
                width="100%"
                nextId={'boldIcon'}
                prevId={'label'}
                // onSelect={(val) => {
                //   setLblFont(val.id)
                // }}
                onSelect={(val) => {
                  handleFontChange(val)
                }}
              />
            </Box>
            <Box sx={{ padding: '8px', display: 'flex', marginTop: '5px' }} className={'input--wrapper'}>
              <IconButton
                style={{ background: isBold ? '#f2f9ff' : '', borderRadius: '0px', borderColor: '#0086ff', height: '35px' }}
                onClick={handleToggleBold}
                id={'boldIcon'}
                onKeyDown={(e) => navigation3(e, `addLabelBtn`, `fontSize`)}
                // color="#aaa"
              >
                <FormatBoldIcon style={{ color: '#444444' }} />
              </IconButton>
              <IconButton
                style={{ background: isItalic ? '#f1f1f5' : '', borderRadius: '0px', borderColor: '#a6a8ab', height: '35px' }}
                onClick={handleToggleItalic}
                id={'italicIcon'}
                onKeyDown={(e) => navigation3(e, `underlineIcon`, `boldIcon`)}
                disabled={!items.some(hasSelectedTableCell)}
              >
                <FormatItalicIcon style={{ color: '#666666' }} />
              </IconButton>
              <IconButton
                style={{ background: isUnderline ? '#f1f1f5' : '', borderRadius: '0px', borderColor: '#a6a8ab', height: '35px' }}
                onClick={handleToggleUnderline}
                id={'underlineIcon'}
                onKeyDown={(e) => navigation3(e, `addLabelBtn`, `italicIcon`)}
                disabled={!items.some(hasSelectedTableCell)}
              >
                <FormatUnderlinedIcon style={{ color: '#666666' }} />
              </IconButton>
            </Box>
            <Button
              id="addLabelBtn"
              style={{ margin: '0', height: '40px', width: '32%', marginTop: '13px', marginLeft: '8px' }}
              className="btn add-btn"
              variant="contained"
              color="error"
              // onClick={() => {
              //   handleAddItem(lblText, lblFont, isBold, isItalic, isUnderline, 10, 10, Math.random().toString(36).substring(7))
              // }}
              onClick={() => {
                // if (formatType === 'Pre-Printed') {
                //   handleAddTwoItems()
                // } else {
                //   handleAddItem(lblText, lblFont, isBold, isItalic, isUnderline, 10, 10, Math.random().toString(36).substring(7))
                // }
                handleAddTwoItems()
              }}
              onKeyDown={(e) => {
                navigation1(e, `addLogoOrQr`, 'boldIcon')
              }}
            >
              {tr('wbAddLabel', 'Add Label')}
            </Button>
          </Box>

          <Box style={{ display: 'flex', width: '50%' }}>
            <Box sx={{ padding: '8px', marginTop: '5px' }} className={'input--wrapper'}>
              <DropDownOA
                id={'addLogoOrQr'}
                label={tr('gsAdd', 'Add')}
                data={imgList}
                defaultvalue={imgList[0].name}
                value={imgType}
                idKey={`id`}
                dataKey={`name`}
                width="100%"
                nextId={'imgRatio'}
                prevId={'addLabelBtn'}
                onSelect={(val) => {
                  if (val.name === 'QR') {
                    setImgType(val.name)
                    setSelectedRatio('1:1')
                  } else {
                    setImgType(val.name)
                  }
                }}
              />
            </Box>
            <Box sx={{ padding: '8px', marginTop: '5px' }} className={'input--wrapper'}>
              <DropDownOA
                id={'imgRatio'}
                label={tr('wbRatio', 'Ratio')}
                data={ratioList}
                defaultvalue={ratioList[0].name}
                value={selectedRatio}
                idKey={`id`}
                dataKey={`name`}
                width="100%"
                nextId={'imgHeight'}
                prevId={'addLogoOrQr'}
                disabled={imgType == 'QR' ? true : false}
                onSelect={(e) => {
                  handleRatioChange(e)
                }}
              />
            </Box>
            <Box sx={{ padding: '8px', marginTop: '5px' }} className={'input--wrapper'}>
              <Lineinput
                id={'imgHeight'}
                label={tr('wbHeightPx', 'Height.(px)')}
                type="text"
                name="imgHeight"
                value={imgHeight}
                // sx={{ margin: '8px', width: '100%' }}
                // onChange={(e) => setImgHeight(e.target.value)}
                onChange={(e) => handleHeightChange(e)}
                // onBlur={(e) => {
                //   handleWebsiteChange(e)
                // }}
                onKeyDown={(e) => navigation1(e, 'addImgBtn', 'imgRatio')}
                style={{ with: '75%' }}
              />
            </Box>
            <Box sx={{ padding: '8px', marginTop: '5px' }} className={'input--wrapper'}>
              <Lineinput
                id={'imgWidth'}
                label={tr('wbWidthPx', 'Width(px)')}
                type="text"
                name="imgWidth"
                value={imgWidth}
                sx={{ margin: '8px', width: '100%' }}
                // onChange={(e) => setImgWidth(e.target.value)}
                //disble={true}
                disabled
              />
            </Box>
            <Button
              id="addImgBtn"
              style={{ margin: '0', height: '40px', width: '46%', marginTop: '13px', marginLeft: '8px' }}
              className="btn add-btn"
              variant="contained"
              color="error"
              onClick={() => {
                handleAddItem(imgType, 12, 0, 0, 0, 10, 10, Math.random().toString(36).substring(7), imgHeight, imgWidth, 'lightblue')
              }}
              onKeyDown={(e) => {
                navigation1(e, `upBtn`, 'imgHeight')
              }}
            >
              {tr('wbAddImage', 'Add Image')}
            </Button>
          </Box>
        </Stack>
        <Divider />
        <Grid container spacing={2} style={{ height: '100vh', marginTop: '0px', display: isUpdate ? '' : isTicketGenerate ? '' : 'none' }}>
          {/* 70% section */}

          <Grid item xs={12} sm={8} style={{ borderRight: '1px solid rgb(204, 204, 204)', paddingRight: '16px', paddingTop: '0px' }}>
            {/* <lable>Ticket</lable> */}
            {/* <Typography variant="h6" gutterBottom>
              Ticket
            </Typography> */}
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '7px', marginTop: '7px' }}>
              <Typography
                variant="h6"
                gutterBottom
                style={{
                  fontFamily: 'Roboto',
                  fontWeight: '700',
                  fontSize: '14px',
                  lineHeight: '22px',
                  letterSpacing: '0.5px',
                  color: '#444444',
                  marginBottom: '0px',
                }}
              >
                {tr('wbTicket', 'TICKET')}
              </Typography>
              <Typography
                variant="h6"
                gutterBottom
                style={{
                  fontFamily: 'Roboto',
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '22px',
                  letterSpacing: '0.5px',
                  color: '#444444',
                  marginBottom: '0px',
                }}
              >
                {/* {'(' + ticketHeight + 'X' + ticketWidth + ')'} */}
                {` (${ticketHeight}MM X ${ticketWidth}MM)`}
              </Typography>
              {/* Zoom Buttons */}
              <div style={{ display: 'flex', marginLeft: 'auto' }}>
                <Typography
                  variant="h6"
                  gutterBottom
                  style={{
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    fontSize: '14px',
                    lineHeight: '22px',
                    letterSpacing: '0.5px',
                    color: '#444444',
                    marginBottom: '0px',
                  }}
                >
                  {tr('wbZoom', 'ZOOM')}
                </Typography>
                <IconButton
                  //color="red"
                  style={{ padding: '0px', margin: '0px 5px 0px 5px', borderRadius: '0px', borderColor: '#a6a8ab', height: '22px' }}
                  onClick={handleZoomIn}
                >
                  <AddIcon style={{ color: '#444444' }} />
                </IconButton>
                <Typography
                  variant="h6"
                  gutterBottom
                  style={{
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    fontSize: '14px',
                    lineHeight: '22px',
                    letterSpacing: '0.5px',
                    color: '#444444',
                    marginBottom: '0px',
                    cursor: 'pointer', // Set cursor to pointer for better UX
                    // backgroundColor: '#f1f1f5', // Initial background color
                    transition: 'rgb(241 241 245) 0.3s ease', // Smooth transition on hover and click
                  }}
                  onClick={handleZoomReset}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = '#e0e0e0' // Change background color on hover
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent' // Reset background color on mouse out
                  }}
                >
                  100%
                </Typography>
                <IconButton
                  //color="red"
                  style={{ padding: '0px', margin: '0px 5px 0px 5px', borderRadius: '0px', borderColor: '#a6a8ab', height: '22px' }}
                  onClick={handleZoomOut}
                >
                  <RemoveIcon style={{ color: '#444444' }} />
                </IconButton>
              </div>
            </div>
            <Paper
              style={{
                height: '90%',
                //display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                boxShadow: 'none',
                background: '#F5F5F5',
                border: '5px double rgb(204, 204, 204)',
                overflow: 'auto',
                maxHeight: '450px',
                padding: '16px',

                // border-radius: 8px;
                // border: 2px solid lightgray;
              }}
              className="scroll"
            >
              {/* {!isTicketGenerate ? (
                <div
                  style={{
                    width: '100%',
                    height: '100px',
                    fontSize: '16px',
                    fontWeight: '500',
                    textAlign: 'center',
                    color: '#666666',
                    fontFamily: 'Roboto',
                  }}
                >
                  Create A New One..
                </div>
              ) : ( */}

              <DragAndDropContainer
                id={'containerId'}
                items={items}
                isPrePrinted={formatType === 'Pre-Printed' ? true : false}
                width={ticketWidth}
                height={ticketHeight}
                headerHeigth={ticketHeaderHeight}
                footerHeight={ticketFooterHeight}
                setItems={updateSetItems}
                horizontal={horizontal}
                vertical={vertical}
                marginInfo={margin}
                scale={scale}
              />

              {/* )} */}
            </Paper>
          </Grid>

          {/* 30% section */}
          <Grid item xs={12} sm={4} style={{ paddingTop: '0px' }}>
            {/* <lable>Ticket</lable> */}
            <Typography
              variant="h6"
              gutterBottom
              style={{
                fontFamily: 'Roboto',
                fontWeight: '600',
                fontSize: '14px',
                lineHeight: '22px',
                letterSpacing: '0.5px',
                color: '#444444',
                marginTop: '7px',
              }}
            >
              {tr('wbMoveSelected', 'MOVE SELECTED')}
            </Typography>
            <Paper style={{ height: '90%', padding: '0px', boxShadow: 'none' }}>
              {/* Buttons and Inputs */}
              <Grid container spacing={2} justifyContent="center">
                <Grid item xs={12} textAlign="center">
                  <Button
                    id="upBtn"
                    style={{ margin: '0', height: '40px' }}
                    className="btn add-btn"
                    variant="contained"
                    color="error"
                    onClick={() => moveItem('up')}
                    onKeyDown={(e) => navigationDirectionBtn(e, `leftBtn`, `addImgBtn`)}
                  >
                    {tr('wbUp', 'UP')}
                    <ArrowUpwardIcon />
                  </Button>
                </Grid>
                <Grid item container justifyContent="center" style={{ paddingTop: '8px' }}>
                  <Grid item>
                    <Button
                      id="leftBtn"
                      style={{ margin: '0', height: '40px' }}
                      className="btn add-btn"
                      variant="contained"
                      color="error"
                      onClick={() => moveItem('left')}
                      onKeyDown={(e) => navigationDirectionBtn(e, `downBtn`, `upBtn`)}
                    >
                      <KeyboardBackspaceRoundedIcon style={{ marginRight: '3px' }} />
                      {tr('wbLf', 'LF')}
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      id="downBtn"
                      style={{ marginLeft: '8px', marginRight: '8px', height: '40px' }}
                      className="btn add-btn"
                      variant="contained"
                      color="error"
                      onClick={() => moveItem('down')}
                      onKeyDown={(e) => navigationDirectionBtn(e, `rightBtn`, `leftBtn`)}
                    >
                      {tr('wbDn', 'DN')} <ArrowDownwardIcon />
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      id="rightBtn"
                      style={{ margin: '0', height: '40px' }}
                      className="btn add-btn"
                      variant="contained"
                      color="error"
                      onClick={() => moveItem('right')}
                      onKeyDown={(e) => navigationDirectionBtn(e, `selectAllBtn`, `downBtn`)}
                    >
                      {tr('wbRn', 'RN')}
                      <ArrowForwardIcon style={{ marginLeft: '3px' }} />
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <div style={{ display: 'flex', alignItems: 'center', paddingTop: '8px', paddingBottom: '8px' }}>
                <Item sx={{ ...sx.itemsx, paddingX: '6px' }} className="itemButtons">
                  <Button
                    variant="outlined"
                    sx={{ width: '100%' }}
                    id="selectAllBtn"
                    className="receiveitembtn"
                    onClick={() => handleSelectAll()}
                    onKeyDown={(e) => navigation3(e, `clearBtn`, `rightBtn`)}
                  >
                    {tr('wbSelectAll', 'SELECT ALL')}
                  </Button>
                </Item>
                <Item sx={{ ...sx.itemsx, paddingX: '6px' }} className="itemButtons">
                  <Button
                    variant="outlined"
                    sx={{ width: '100%' }}
                    id="clearBtn"
                    className="receiveitembtn"
                    onClick={() => clearSelectedItems()}
                    onKeyDown={(e) => navigation3(e, `alignLeft`, `selectAllBtn`)}
                    style={{ width: '112px' }}
                  >
                    {tr('wbClear', 'CLEAR')}
                  </Button>
                </Item>
                <lable
                  style={{
                    color: '#444444',
                    fontSize: '12px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    lineHeight: '22px',
                    letterSpacing: '0.5px',
                    marginLeft: 'auto',
                  }}
                >
                  {tr('wbAlignment', 'ALIGNMENT')}
                </lable>
                {/* Alignment Icons */}

                <IconButton
                  id="alignLeft"
                  color="primary"
                  onClick={() => alignSelectedItems('left')}
                  onKeyDown={(e) => navigation3(e, `alignCenter`, `clearBtn`)}
                >
                  <FormatAlignLeftIcon style={{ color: '#666666' }} />
                </IconButton>
                <IconButton
                  id="alignCenter"
                  color="primary"
                  onClick={() => alignSelectedItems('center')}
                  onKeyDown={(e) => navigation3(e, `alignRight`, `alignLeft`)}
                >
                  <FormatAlignCenterIcon style={{ color: '#666666' }} />
                </IconButton>
                <IconButton
                  id="alignRight"
                  color="primary"
                  onClick={() => alignSelectedItems('right')}
                  style={{ paddingRight: '0px' }}
                  onKeyDown={(e) => navigation3(e, `marginLeft`, `alignCenter`)}
                >
                  <FormatAlignRightIcon style={{ color: '#666666' }} />
                </IconButton>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <label
                  style={{
                    color: '#444444',
                    fontSize: '12px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    lineHeight: '22px',
                    letterSpacing: '0.5px',
                    marginRight: '8px',
                  }}
                >
                  {tr('wbMargin', 'MARGIN')}
                </label>
                <div style={{ borderBottom: '1px solid #ccc', flex: 1 }}></div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', color: '#444' }}>
                <Box
                  sx={{ padding: '8px', paddingLeft: '0px', paddingRight: '0px' }}
                  style={{ marginBottom: '0px' }}
                  className={'input--wrapper'}
                >
                  <Lineinput
                    id={'marginRight'}
                    label={tr('wbRightPx', 'Right(px)')}
                    type="text"
                    name="Helpline No."
                    value={marginInfo.right}
                    sx={{ margin: '8px', width: '100%' }}
                    onChange={(e) => setMarginInfo((prevMargin) => ({ ...prevMargin, right: e.target.value }))}
                    //setMarginInfo
                    //onBlur={(e) => handleHelplineNumberChange(e)}
                    onKeyDown={(e) => navigation1(e, 'marginLeft', 'alignRight')}
                    disabled
                  />
                </Box>
                <Box sx={{ padding: '8px' }} style={{ marginBottom: '0px' }} className={'input--wrapper'}>
                  <Lineinput
                    id={'marginLeft'}
                    label={tr('wbLeftPx', 'Left(px)')}
                    type="text"
                    name="Helpline No."
                    value={marginInfo.left}
                    sx={{ margin: '8px', width: '100%' }}
                    onChange={(e) => setMarginInfo((prevMargin) => ({ ...prevMargin, left: e.target.value }))}
                    //onBlur={(e) => handleHelplineNumberChange(e)}
                    onKeyDown={(e) => navigation1(e, 'addMargin', 'alignRight')}
                  />
                </Box>
                <Box
                  sx={{ padding: '8px', paddingLeft: '0px', paddingRight: '0px' }}
                  style={{ marginBottom: '0px' }}
                  className={'input--wrapper'}
                >
                  <Lineinput
                    id={'marginUp'}
                    label={tr('wbUpPx', 'Up(px)')}
                    type="text"
                    name="Helpline No."
                    value={marginInfo.up}
                    sx={{ margin: '8px', width: '100%' }}
                    onChange={(e) => setMarginInfo((prevMargin) => ({ ...prevMargin, up: e.target.value }))}
                    //onBlur={(e) => handleHelplineNumberChange(e)}
                    onKeyDown={(e) => navigation1(e, 'marginDown', 'marginLeft')}
                    disabled
                  />
                </Box>
                <Box sx={{ padding: '8px' }} style={{ marginBottom: '0px' }} className={'input--wrapper'}>
                  <Lineinput
                    id={'marginDown'}
                    label={tr('wbDownPx', 'Down(px)')}
                    type="text"
                    name="Helpline No."
                    value={marginInfo.down}
                    sx={{ margin: '8px', width: '100%' }}
                    onChange={(e) => setMarginInfo((prevMargin) => ({ ...prevMargin, down: e.target.value }))}
                    //onBlur={(e) => handleHelplineNumberChange(e)}
                    onKeyDown={(e) => navigation1(e, 'addMargin', 'marginUp')}
                    disabled
                  />
                </Box>
                <Item sx={{ ...sx.itemsx }} className="itemButtons">
                  <Button
                    variant="outlined"
                    sx={{ width: '100%' }}
                    id="addMargin"
                    className="receiveitembtn"
                    onClick={() => {
                      adjustPositionWithMargin()
                    }}
                    onKeyDown={(e) => navigation3(e, `horizontalThermalSeparation`, `marginLeft`)}
                  >
                    {tr('gsAdd', 'Add')}
                  </Button>
                </Item>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', color: '#444' }}>
                <label
                  style={{
                    color: '#444444',
                    fontSize: '12px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    lineHeight: '22px',
                    letterSpacing: '0.5px',
                    marginRight: '8px',
                  }}
                >
                  {tr('wbThermalSplitter', 'THERMAL SPLITTER SEPARATION')}
                </label>
                <div style={{ borderBottom: '1px solid #ccc', flex: 1 }}></div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', color: '#444' }}>
                <Box
                  sx={{ padding: '8px', paddingLeft: '0px', paddingRight: '0px' }}
                  style={{ marginBottom: '0px' }}
                  className={'input--wrapper'}
                >
                  <Lineinput
                    id={'horizontalThermalSeparation'}
                    label={tr('wbHorizontalMm', 'Horizontal (MM)')}
                    type="text"
                    name="Helpline No."
                    value={thermalSplitter.horizontal}
                    sx={{ margin: '8px', width: '100%' }}
                    onChange={(e) => {
                      // setHorizontal(e.target.value)
                      setThermalSplitter((prev) => ({ ...prev, horizontal: e.target.value }))
                    }}
                    //onBlur={(e) => handleHelplineNumberChange(e)}
                    onKeyDown={(e) => navigation1(e, 'addThermalSeparation', 'addMargin')}
                  />
                </Box>
                <Box sx={{ padding: '8px' }} style={{ marginBottom: '0px' }} className={'input--wrapper'}>
                  <Lineinput
                    id={'verticalThermalSeparation'}
                    label={tr('wbVerticalMm', 'Vertical (MM)')}
                    type="text"
                    name="Helpline No."
                    value={thermalSplitter.vertical}
                    sx={{ margin: '8px', width: '100%' }}
                    onChange={(e) => {
                      // setVertical(e.target.value)
                      setThermalSplitter((prev) => ({ ...prev, vertical: e.target.value }))
                    }}
                    //onBlur={(e) => handleHelplineNumberChange(e)}
                    onKeyDown={(e) => navigation1(e, 'addThermalSeparation', 'horizontalThermalSeparation')}
                    disabled
                  />
                </Box>
                <Item sx={{ ...sx.itemsx }} className="itemButtons">
                  <Button
                    variant="outlined"
                    sx={{ width: '100%' }}
                    id="addThermalSeparation"
                    className="receiveitembtn"
                    onClick={() => {
                      handleAddThermalPrintSplitter()
                    }}
                    onKeyDown={(e) => navigation3(e, `statusId`, `horizontalThermalSeparation`)}
                  >
                    {tr('gsAdd', 'Add')}
                  </Button>
                </Item>
              </div>

              <div style={{ display: 'flex', alignItems: 'center' }}>
                <label
                  style={{
                    color: '#444444',
                    fontSize: '12px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    lineHeight: '22px',
                    letterSpacing: '0.5px',
                    marginRight: '8px',
                  }}
                >
                  {tr('wbTable', 'TABLE')}
                </label>
                <div style={{ borderBottom: '1px solid #ccc', flex: 1 }}></div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', color: '#444' }}>
                <Box
                  sx={{ padding: '8px', paddingLeft: '0px', paddingRight: '0px' }}
                  style={{ marginBottom: '0px' }}
                  className={'input--wrapper'}
                >
                  <Lineinput
                    id={'tblRow'}
                    label={tr('wbRow', 'Row')}
                    type="text"
                    name="Table Row"
                    value={tableInfo?.row}
                    sx={{ margin: '8px', width: '100%' }}
                    onChange={(e) => setTableInfo((prevInfo) => ({ ...prevInfo, row: e.target.value }))}
                    onKeyDown={(e) => navigation1(e, 'tblCol', 'addThermalSeparation')}
                  />
                </Box>
                <Box sx={{ padding: '8px' }} style={{ marginBottom: '0px' }} className={'input--wrapper'}>
                  <Lineinput
                    id={'tblCol'}
                    label={tr('wbCol', 'Col')}
                    type="text"
                    name="tblCol"
                    value={tableInfo?.col}
                    sx={{ margin: '8px', width: '100%' }}
                    onChange={(e) => setTableInfo((prevInfo) => ({ ...prevInfo, col: e.target.value }))}
                    onKeyDown={(e) => navigation1(e, 'tblCellHeight', 'tblRow')}
                  />
                </Box>
                <Box
                  sx={{ padding: '8px', paddingLeft: '0px', paddingRight: '0px' }}
                  style={{ marginBottom: '0px' }}
                  className={'input--wrapper'}
                >
                  <Lineinput
                    id={'tblCellHeight'}
                    label={tr('wbHPx', 'H(Px)')}
                    type="text"
                    name="tblCellHeight"
                    value={tableInfo?.tblHeight}
                    sx={{ margin: '8px', width: '100%' }}
                    onChange={(e) => setTableInfo((prevInfo) => ({ ...prevInfo, tblHeight: e.target.value }))}
                    onKeyDown={(e) => navigation1(e, 'tblCellWidth', 'tblCol')}
                  />
                </Box>
                <Box sx={{ padding: '8px' }} style={{ marginBottom: '0px' }} className={'input--wrapper'}>
                  <Lineinput
                    id={'tblCellWidth'}
                    label={tr('wbWPx', 'W(Px)')}
                    type="text"
                    name="tblCellWidth"
                    value={tableInfo?.tblWidth}
                    sx={{ margin: '8px', width: '100%' }}
                    onChange={(e) => setTableInfo((prevInfo) => ({ ...prevInfo, tblWidth: e.target.value }))}
                    onKeyDown={(e) => navigation1(e, 'leftAlign', 'tblCellHeight')}
                  />
                </Box>
                <IconButton
                  id="leftAlign"
                  color="primary"
                  onClick={() => alignTableCells('left')}
                  onKeyDown={(e) => navigation3(e, `centerAlign`, `tblCellWidth`)}
                  style={{ background: tableInfo.alignment === 'left' ? '#f1f1f5' : '' }}
                >
                  <FormatAlignLeftIcon style={{ color: '#666666' }} />
                </IconButton>
                <IconButton
                  id="centerAlign"
                  color="primary"
                  onClick={() => alignTableCells('center')}
                  onKeyDown={(e) => navigation3(e, `rightAlign`, `leftAlign`)}
                  style={{ background: tableInfo.alignment === 'center' ? '#f1f1f5' : '' }}
                >
                  <FormatAlignCenterIcon style={{ color: '#666666' }} />
                </IconButton>
                <IconButton
                  id="rightAlign"
                  color="primary"
                  onClick={() => alignTableCells('right')}
                  onKeyDown={(e) => navigation3(e, `addTable`, `centerAlign`)}
                  style={{ background: tableInfo.alignment === 'right' ? '#f1f1f5' : '' }}
                >
                  <FormatAlignRightIcon style={{ color: '#666666' }} />
                </IconButton>
                <Item sx={{ ...sx.itemsx }} className="itemButtons">
                  <Button
                    variant="outlined"
                    sx={{ width: '100%' }}
                    id="addTable"
                    className="receiveitembtn"
                    onClick={handleAddTable}
                    onKeyDown={(e) => navigation3(e, `statusId`, `rightAlign`)}
                  >
                    {tr('wbAddTable', 'Add')}
                  </Button>
                </Item>
              </div>
              <Divider style={{ marginTop: '8px', marginBottom: '11px' }} />
              <Box
                className="beachTransBottomSec"
                sx={{ display: isUpdate ? 'flex' : isTicketGenerate ? 'flex' : 'none', padding: '5px 0px' }}
              >
                <Item sx={{ width: '60%', padding: '0px', marginRight: '8px' }}>
                  <DropDownOA
                    key={`status-${language}-${isActive?.name}`}
                    id={'statusId'}
                    label={tr('gsStatus', 'Status')}
                    defaultvalue={isActive?.name || ''}
                    data={translatedStatusList || []}
                    isObjArr={true}
                    dataKey={`name`}
                    idKey={`id`}
                    width="100%"
                    searchPlaceholder={tr('searchStatus', 'Search Status')}
                    nextId={'cancelModalBtn'}
                    prevId={'addTable'}
                    color={true}
                    isSuccess={isActive?.id === 1}
                    isError={isActive?.id === 0}
                    onSelect={(value) => {
                      setIsActive(translatedStatusList.find((s) => s.id === value.id) || value)
                    }}
                  />
                </Item>
                <Button
                  id="cancelModalBtn"
                  className="cancel-btn"
                  variant="outlined"
                  color="error"
                  style={{ height: '40px', color: '#fe5200', fontSize: 'medium', marginLeft: 'auto', marginRight: '8px' }}
                  onClick={() => {
                    isUpdate ? updateModal(false, mdt.ticketFormat) : updateModal(false, mdt.ticketFormat)
                  }}
                  onKeyDown={(e) => {
                    navigation1(e, `saveBtn`, 'statusId')
                  }}
                >
                  {tr('cancel', 'Cancel')}
                </Button>
                <Button
                  id="saveBtn"
                  style={{ margin: '0', height: '40px' }}
                  className="btn add-btn"
                  variant="contained"
                  color="error"
                  onClick={handleSaveAndUpdateTicket}
                  onKeyDown={(e) => {
                    navigation1(e, `formatName`, 'cancelModalBtn')
                  }}
                >
                  {isUpdate ? tr('updateTitle', 'Update') : tr('saveTitle', 'Save')}
                </Button>
              </Box>
            </Paper>
          </Grid>
        </Grid>
        {/* <Divider /> */}
      </Stack>
    </Modal>
  )
}

export default CreateNewFormatDesign
